module.exports = __webpack_public_path__ + "static/media/elDesafio.f5df3b7e.webp";